import axios from 'axios';
import Auth from '../lib/auth';
import utilsLib from './utils.lib';
import { addNotification } from './notifications';
import {saveFile} from "../lib/content-lib";

export const GET_PURCHASE_ORDERS_REQUEST = 'GET_PURCHASE_ORDERS_REQUEST';
export const GET_PURCHASE_ORDERS_SUCCESS = 'GET_PURCHASE_ORDERS_SUCCESS';
export const GET_PURCHASE_ORDERS_ERROR = 'GET_PURCHASE_ORDERS_ERROR';

export const GET_PURCHASE_ORDER_REQUEST = 'GET_PURCHASE_ORDER_REQUEST';
export const GET_PURCHASE_ORDER_SUCCESS = 'GET_PURCHASE_ORDER_SUCCESS';
export const GET_PURCHASE_ORDER_ERROR = 'GET_PURCHASE_ORDER_ERROR';

export const CREATE_PURCHASE_ORDER_REQUEST = 'CREATE_PURCHASE_ORDER_REQUEST';
export const CREATE_PURCHASE_ORDER_SUCCESS = 'CREATE_PURCHASE_ORDER_SUCCESS';
export const CREATE_PURCHASE_ORDER_ERROR = 'CREATE_PURCHASE_ORDER_ERROR';

export const UPDATE_PURCHASE_ORDER_REQUEST = 'UPDATE_PURCHASE_ORDER_REQUEST';
export const UPDATE_PURCHASE_ORDER_SUCCESS = 'UPDATE_PURCHASE_ORDER_SUCCESS';
export const UPDATE_PURCHASE_ORDER_ERROR = 'UPDATE_PURCHASE_ORDER_ERROR';

export const CHANGE_STATUS_PURCHASE_ORDER_REQUEST = 'CHANGE_STATUS_PURCHASE_ORDER_REQUEST';
export const CHANGE_STATUS_PURCHASE_ORDER_SUCCESS = 'CHANGE_STATUS_PURCHASE_ORDER_SUCCESS';
export const CHANGE_STATUS_PURCHASE_ORDER_ERROR = 'CHANGE_STATUS_PURCHASE_ORDER_ERROR';

export const UPLOAD_PURCHASE_ORDER_FILES_REQUEST = 'UPLOAD_PURCHASE_ORDER_FILES_REQUEST';
export const UPLOAD_PURCHASE_ORDER_FILES_PROGRESS = 'UPLOAD_PURCHASE_ORDER_FILES_PROGRESS';
export const UPLOAD_PURCHASE_ORDER_FILES_SUCCESS = 'UPLOAD_PURCHASE_ORDER_FILES_SUCCESS';
export const UPLOAD_PURCHASE_ORDER_FILES_ERROR = 'UPLOAD_PURCHASE_ORDER_FILES_ERROR';

export const DELETE_PURCHASE_ORDER_FILE_REQUEST = 'DELETE_PURCHASE_ORDER_FILE_REQUEST';
export const DELETE_PURCHASE_ORDER_FILE_SUCCESS = 'DELETE_PURCHASE_ORDER_FILE_SUCCESS';
export const DELETE_PURCHASE_ORDER_FILE_ERROR = 'DELETE_PURCHASE_ORDER_FILE_ERROR';

export const DELETE_PURCHASE_ORDER_REQUEST = 'DELETE_PURCHASE_ORDER_REQUEST';
export const DELETE_PURCHASE_ORDER_SUCCESS = 'DELETE_PURCHASE_ORDER_SUCCESS';
export const DELETE_PURCHASE_ORDER_ERROR = 'DELETE_PURCHASE_ORDER_ERROR';

export const CLEAN_PURCHASE_ORDERS = 'CLEAN_PURCHASE_ORDERS';

// Get purchaseOrders
export function getPurchaseOrders(query) {
    return async (dispatch) => {
        try {
            dispatch(getPurchaseOrdersRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/purchase-orders/query', query, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getPurchaseOrdersSuccess, getPurchaseOrdersError));
        } catch (err) {
            dispatch(utilsLib.response(err, getPurchaseOrdersError));
        }
    };
}
function getPurchaseOrdersRequest() {
    return {
        type: GET_PURCHASE_ORDERS_REQUEST,
        isFetching: true
    };
}
function getPurchaseOrdersSuccess (payload) {
    return {
        type: GET_PURCHASE_ORDERS_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}
function getPurchaseOrdersError(errorMessage) {
    return {
        type: GET_PURCHASE_ORDERS_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Get purchaseOrder
export function getPurchaseOrder(purchaseOrderId) {

    return async (dispatch) => {
        try {
            dispatch(getPurchaseOrderRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.get(`/api/purchase-orders/${purchaseOrderId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getPurchaseOrderSuccess, getPurchaseOrderError));
        } catch (err) {
            dispatch(utilsLib.response(err, getPurchaseOrderError));
        }
    };
}
function getPurchaseOrderRequest() {
    return {
        type: GET_PURCHASE_ORDER_REQUEST,
        isFetching: true
    };
}
function getPurchaseOrderSuccess (payload) {
    return {
        type: GET_PURCHASE_ORDER_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}
function getPurchaseOrderError(errorMessage) {
    return {
        type: GET_PURCHASE_ORDER_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Create purchaseOrder
export function createPurchaseOrder(purchaseOrder, options) {
    return async (dispatch) => {
        try {
            dispatch(createPurchaseOrderRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/purchase-orders', { purchaseOrder, options }, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, createPurchaseOrderSuccess, createPurchaseOrderError));
        } catch (err) {
            dispatch(utilsLib.response(err, createPurchaseOrderError));
        }
    };
}
function createPurchaseOrderRequest() {
    return {
        type: CREATE_PURCHASE_ORDER_REQUEST,
        isFetching: true
    };
}
function createPurchaseOrderSuccess (payload) {
    return dispatch => {
        // Create notification for create purchaseOrder success
        dispatch(addNotification({
            message: 'Pedido añadido correctamente',
            color: 'green',
            icon: 'tick'
        }));

        dispatch({
            type: CREATE_PURCHASE_ORDER_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function createPurchaseOrderError(errorMessage) {
    return dispatch => {
        // Create notification for create purchaseOrder error
        dispatch(addNotification({
            message: 'Error al añadir el pedido',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CREATE_PURCHASE_ORDER_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Update purchaseOrder
export function updatePurchaseOrder(purchaseOrderId, purchaseOrder = {}) {
    return async (dispatch) => {
        try {
            dispatch(updatePurchaseOrderRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/purchase-orders/${purchaseOrderId}`, purchaseOrder, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, updatePurchaseOrderSuccess, updatePurchaseOrderError));
        } catch (err) {
            dispatch(utilsLib.response(err, updatePurchaseOrderError));
        }
    };
}
function updatePurchaseOrderRequest() {
    return {
        type: UPDATE_PURCHASE_ORDER_REQUEST,
        isFetching: true
    };
}
function updatePurchaseOrderSuccess (payload) {
    return dispatch => {
        // Create notification for update purchaseOrder success
        dispatch(addNotification({
            message: 'Pedido actualizado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: UPDATE_PURCHASE_ORDER_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function updatePurchaseOrderError(errorMessage) {
    return dispatch => {
        // Create notification for update purchaseOrder error
        dispatch(addNotification({
            message: 'Error al actualizar el pedido',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPDATE_PURCHASE_ORDER_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Change purchaseOrder status
export function changePurchaseOrderStatus(purchaseOrderId, status, options = { populateRefs: true, calculateStatistics: 'purchase-order' }) {
    return async (dispatch) => {
        try {
            dispatch(changePurchaseOrderStatusRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/purchase-orders/${purchaseOrderId}/status`, { status, options }, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, changePurchaseOrderStatusSuccess, changePurchaseOrderStatusError));
        } catch (err) {
            dispatch(utilsLib.response(err, changePurchaseOrderStatusError));
        }
    };
}
function changePurchaseOrderStatusRequest() {
    return {
        type: CHANGE_STATUS_PURCHASE_ORDER_REQUEST,
        isFetching: true
    };
}
function changePurchaseOrderStatusSuccess (payload) {
    return dispatch => {
        // Create notification for update status success
        dispatch(addNotification({
            message: 'Estado actualizado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: CHANGE_STATUS_PURCHASE_ORDER_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function changePurchaseOrderStatusError(errorMessage) {
    return dispatch => {
        // Create notification for update status error
        dispatch(addNotification({
            message: 'Error al actualizar el estado',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CHANGE_STATUS_PURCHASE_ORDER_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Upload purchaseOrder files
export function uploadPurchaseOrderFiles(purchaseOrderId, files) {
    return async (dispatch) => {
        try {
            dispatch(uploadPurchaseOrderFilesRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post(`/api/purchase-orders/${purchaseOrderId}/files`, files, {
                headers: { 'Authorization': 'Bearer ' + token },
                onUploadProgress: function (e) {
                    dispatch(uploadPurchaseOrderFilesProgress(e.loaded / e.total))
                }
            });

            dispatch(utilsLib.response(res, uploadPurchaseOrderFilesSuccess, uploadPurchaseOrderFilesError));
        } catch (err) {
            dispatch(utilsLib.response(err, uploadPurchaseOrderFilesError));
        }
    };
}
function uploadPurchaseOrderFilesRequest() {
    return {
        type: UPLOAD_PURCHASE_ORDER_FILES_REQUEST,
        isFetching: true
    };
}
function uploadPurchaseOrderFilesProgress(percent) {
    return {
        type: UPLOAD_PURCHASE_ORDER_FILES_PROGRESS,
        percent
    };
}
function uploadPurchaseOrderFilesSuccess (payload) {
    return dispatch => {
        // Create notification for upload purchaseOrder file success
        dispatch(addNotification({
            message: 'Ficheros subidos correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: UPLOAD_PURCHASE_ORDER_FILES_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function uploadPurchaseOrderFilesError(errorMessage) {
    return dispatch => {
        // Create notification for upload purchaseOrder file error
        dispatch(addNotification({
            message: 'Error al subir los ficheros',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPLOAD_PURCHASE_ORDER_FILES_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Download purchaseOrder file
export function downloadPurchaseOrderFile(purchaseOrderId, fileId) {
    return async (dispatch) => {
        try {
            const token = Auth.getLocalJwt();
            const res = await axios.get(`/api/purchase-orders/${purchaseOrderId}/files/${fileId}`, {
                headers: { 'Authorization': 'Bearer ' + token },
                responseType: 'blob'
            });

            if( res.status === 200 ) {
                saveFile(res);
            }

        } catch (err) {
            dispatch(addNotification({
                message: 'Error al descargar el fichero',
                color: 'red',
                icon: 'warning-sign'
            }));
        }
    };
}

// Delete purchaseOrder file
export function deletePurchaseOrderFile(purchaseOrderId, fileId) {
    return async (dispatch) => {
        try {
            dispatch(deletePurchaseOrderFileRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/purchase-orders/${purchaseOrderId}/files/${fileId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deletePurchaseOrderFileSuccess, deletePurchaseOrderFileError));
        } catch (err) {
            dispatch(utilsLib.response(err, deletePurchaseOrderFileError));
        }
    };
}
function deletePurchaseOrderFileRequest() {
    return {
        type: DELETE_PURCHASE_ORDER_FILE_REQUEST,
        isFetching: true
    };
}
function deletePurchaseOrderFileSuccess (payload) {
    return dispatch => {
        // Create notification for delete file success
        dispatch(addNotification({
            message: 'Fichero eliminado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_PURCHASE_ORDER_FILE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function deletePurchaseOrderFileError(errorMessage) {
    return dispatch => {
        // Create notification for delete file error
        dispatch(addNotification({
            message: 'Error al eliminar el fichero',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_PURCHASE_ORDER_FILE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Delete purchaseOrder
export function deletePurchaseOrder(purchaseOrderId) {

    return async (dispatch) => {
        try {
            dispatch(deletePurchaseOrderRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/purchase-orders/${purchaseOrderId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deletePurchaseOrderSuccess, deletePurchaseOrderError));
        } catch (err) {
            dispatch(utilsLib.response(err, deletePurchaseOrderError));
        }
    };
}
function deletePurchaseOrderRequest() {
    return {
        type: DELETE_PURCHASE_ORDER_REQUEST,
        isFetching: true
    };
}
function deletePurchaseOrderSuccess (payload) {
    return dispatch => {
        // Create notification for delete purchaseOrder success
        dispatch(addNotification({
            message: 'Pedido eliminado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_PURCHASE_ORDER_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function deletePurchaseOrderError(errorMessage) {
    return dispatch => {
        // Create notification for delete purchaseOrder error
        dispatch(addNotification({
            message: 'Error al eliminar el pedido',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_PURCHASE_ORDER_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Clean purchaseOrders reducer
export function cleanPurchaseOrders() {
    return {
        type: 'CLEAN_PURCHASE_ORDERS',
        isFetching: false,
        error: false,
        payload: []
    }
}



// WEBPACK FOOTER //
// ./src/actions/purchase-orders.js